import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Goal as GoalModel } from '@feathr/blackbox';
import { Radios } from '@feathr/components';

import FormSelect from '../../FormSelect';
import { buildFormSubmissionPredicates } from '../Goal.predicates';
import { useFormGoalSegment } from '../useFormGoalSegment';

interface IProps {
  goal: GoalModel;
}

function FormSubmissionGoal({ goal }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const {
    spacing: { '4': gap },
  } = useMantineTheme();

  const { selectMode, selectedForms, handleSelectMode, handleFormSelection } = useFormGoalSegment({
    goal,
    buildPredicates: buildFormSubmissionPredicates,
    segmentNamePrefix: 'Form Submission Goal',
  });

  const options = [
    { id: 'any', name: t('Any form submission') },
    { id: 'specific', name: t('Submissions on specific form(s)') },
  ];

  return (
    <Flex direction={'column'} gap={gap}>
      <Radios
        helpText={t('Choose which form submissions will be tracked as conversions.')}
        label={t('Form selection')}
        layout={'block'}
        onChange={handleSelectMode}
        options={options}
        value={selectMode}
      />
      {selectMode === 'specific' && (
        <FormSelect
          filters={{ state: 'published' }}
          isMulti={true}
          label={t('Form(s)')}
          onChange={handleFormSelection}
          placeholder={t('Start typing to search forms')}
          showLastModified={true}
          value={selectedForms}
        />
      )}
    </Flex>
  );
}

export default observer(FormSubmissionGoal);
